import { render, staticRenderFns } from "./NavNestedView.vue?vue&type=template&id=85c96466&scoped=true"
import script from "./NavNestedView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavNestedView.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./NavNestedView.vue?vue&type=style&index=0&id=85c96466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.22_css-loader@6.11.0_webpack@5.102.1__lodash@4_56aa1e7e5d1d518316f437ffcea05512/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c96466",
  null
  
)

export default component.exports